export const getWorker = () =>
  new Worker(
    new URL('../web-workers/spreadsheet-parser.worker', import.meta.url),
    {
      type: 'module',
    },
  );
